import { render, staticRenderFns } from "./distributeAbnormal.vue?vue&type=template&id=6f44ffbe&scoped=true"
import script from "./distributeAbnormal.vue?vue&type=script&lang=js"
export * from "./distributeAbnormal.vue?vue&type=script&lang=js"
import style0 from "./distributeAbnormal.vue?vue&type=style&index=0&id=6f44ffbe&prod&lang=scss&scoped=true"
import style1 from "./distributeAbnormal.vue?vue&type=style&index=1&id=6f44ffbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f44ffbe",
  null
  
)

export default component.exports